import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IAlerts } from './alert.interface';

@Component({
    selector: 'mlp-ng-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss']
})

export class AlertSharedComponent implements OnInit {
    @Input() alert: IAlerts;
    @Output() removeAlert = new EventEmitter();

    private alertReady = false;

    get status(): string {
        return (this.alert.status) ? this.alert.status : 'success';
    }

    get timer(): number {
        return (this.alert.timeout) ? this.alert.timeout : 5000;
    }

    get autoHide(): boolean {
        return (typeof this.alert.autoHide === 'boolean') ? this.alert.autoHide : (this.alert.status === 'danger') ? false : true;
    }

    constructor(private el: ElementRef) {}

    ngOnInit(): void {
        if (this.autoHide) {
            setTimeout(_ => {
                this.removeAlert.emit(this.alert);
            }, this.timer);
        }
    }
}
